import React, { useEffect, useState, lazy } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";

import { firestore, getUserEntitlements } from "../../firebase/firebase.utils";
import SuggestedVideosPage from "../suggested-videos-page/suggested-videos-page.component";
import LoadingAnimation from "../../components/loading-animation/loading-animation.component";

import { addLessons, modifyLessons } from "../../redux/lessons/lessons.actions";
import {
	startLoading,
	stopLoading,
} from "../../redux/loading-animation/loading-animation.actions";
import { RelativeDiv, AbsoluteContainer } from "./video-pages-container.styles";
import {
	collection,
	limit,
	onSnapshot,
	orderBy,
	query,
	where,
} from "firebase/firestore";

//import VideoPage from "../video-page/video-page.component";
const VideoPage = lazy(() => import("../video-page/video-page.component"));

const VideoPagesContainerPage = props => {
	var unsubscribe;
	var limitValue = 10;
	var lastTimeBottomWasReached = 0;
	const [hasAccess, setHasAccessProperty] = useState(true);

	const setLessonsSnapshotListener = () => {
		props.startLoading();
		var lessonsRef;

		if (hasAccess) {
			lessonsRef = query(
				collection(firestore, "Videos"),
				where("isAvailable", "==", true),
				orderBy("Date", "desc"),
				limit(limitValue)
			);
		} else {
			lessonsRef = query(
				collection(firestore, "Videos"),
				where("isAvailable", "==", true),
				orderBy("isFree", "desc"),
				orderBy("Date", "desc"),
				limit(limitValue)
			);
		}
		try {
			unsubscribe = onSnapshot(
				lessonsRef,
				{ includeMetadataChanges: false },
				querySnapshot => {
					// This function is getting called twice

					let addLessons = false;
					let modifyLessons = false;
					let lessonsToAdd = [];
					let lessonsToModify = [];

					querySnapshot.docChanges().forEach(change => {
						if (change.type === "added") {
							addLessons = true;
							lessonsToAdd.push(change.doc.data());
						}
						if (change.type === "modified") {
							modifyLessons = true;
							lessonsToModify.push(change.doc.data());
						}
						// Add handling for removed documents if needed
						if (change.type === "removed") {
							// Handle removed documents if necessary
						}
					});

					if (addLessons) {
						props.addLessonsToRedux(lessonsToAdd);
						props.stopLoading();
					} else if (modifyLessons) {
						props.modifyLessons(lessonsToModify);
						props.stopLoading();
					}
				},
				error => {
					console.error("Error getting snapshot: ", error);
				}
			);
		} catch (error) {
			props.stopLoading();
			console.error(error);
		}
	};

	const onScroll = evt => {
		const scrollTop = document.documentElement.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight;
		const windowHeight = document.documentElement.clientHeight;

		if (scrollTop + windowHeight >= scrollHeight - 200) {
			var lastTimePlusFive = lastTimeBottomWasReached + 1000;
			if (Date.now() > lastTimePlusFive) {
				limitValue += 5;
				unsubscribe();
				setLessonsSnapshotListener();
				//why this is getting called twice?
				//
				lastTimeBottomWasReached = Date.now();
			}
		}
	};
	const loadMoreLessonsIfBottomReached = () => {
		window.addEventListener("scroll", onScroll);
	};

	useEffect(() => {
		setLessonsSnapshotListener();
		loadMoreLessonsIfBottomReached();

		getUserEntitlements().then(res => {
			if (res.data.VIP) {
				setHasAccessProperty(true);
			} else {
				setHasAccessProperty(false);
			}
		});

		return componentWillUnmount;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasAccess]);
	const componentWillUnmount = () => {
		unsubscribe();
		window.removeEventListener("scroll", onScroll);
	};

	return (
		<RelativeDiv>
			<Route
				exact
				path={["/home", "/"]}
				render={props => (
					<SuggestedVideosPage hasAccess={hasAccess} {...props} />
				)}
			/>
			<Route exact path={`/videos/:VideoID`}>
				<VideoPage hasAccess={hasAccess} />
			</Route>
			<AbsoluteContainer>
				<LoadingAnimation />
			</AbsoluteContainer>
		</RelativeDiv>
	);
};

const mapDispatchToProps = dispatch => ({
	addLessonsToRedux: lessonsToAdd => dispatch(addLessons(lessonsToAdd)),
	startLoading: () => dispatch(startLoading()),
	stopLoading: () => dispatch(stopLoading()),
	modifyLessons: lessonsToModify => dispatch(modifyLessons(lessonsToModify)),
});

export default connect(null, mapDispatchToProps)(VideoPagesContainerPage);
